import React from 'react';
import { Row } from 'react-bootstrap';
import CLAPreviewPictureWithHOC from '../../CardInformation/CLAPreviewPictureWithHOC';
import { FormSelect, FormText } from '~/components/FormControl';
import { IMG_HEIGHT, IMG_WIDTH } from '~/config/constants';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CheckboxGroup from '~/components/CheckboxGroup/CheckboxGroup';

function SkinForm({ values, resetCount }) {
    const { rarities, sizes } = useSelector((state) => state.cardSaga.characterClassSkin);

    return (
        <>
            <Row className="d-flex flex-column align-items-center justify-content-center my-3">
                <CLAPreviewPictureWithHOC
                    pictureName={'image'}
                    // eslint-disable-next-line react/prop-types
                    pictureVal={values.image}
                    wrapperClass="d-flex flex-column align-items-center justify-content-center"
                    formFileClass={'opacity-100 position-absolute z-n1'}
                    width={IMG_WIDTH}
                    height={IMG_HEIGHT}
                    resetCount={resetCount}
                />
            </Row>
            <Row>
                <FormText
                    sm={6}
                    name="name"
                />
                <FormSelect
                    sm={6}
                    name="rarity"
                    options={rarities}
                />
            </Row>

            {sizes.length > 0 && (
                <CheckboxGroup
                    options={sizes}
                    fieldName="size"
                    isMultiple={false}
                />
            )}
        </>
    );
}

SkinForm.defaultProps = {
    resetCount: 0,
};

SkinForm.propTypes = {
    values: PropTypes.object.isRequired,
    resetCount: PropTypes.number,
};
export default SkinForm;
